import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Switch } from "@tql/ui-components-react/kendo/inputs";
import { Label } from "@tql/ui-components-react/kendo/labels";
import { eye, eyeOff } from "@tql/ui-components-react/untitled/icons";

import * as styles from "./routing-guide-banner.module.css";

type RoutingGuideBannerProps = {
	hiddenCarrierCount: number;
	hasRoutingGuides: boolean;
	isGuideActive: boolean;
	showingHidden: boolean;
	onToggleGuide: () => void;
	onToggleHiddenCarriers: () => void;
};

export function RoutingGuideBanner({
	hiddenCarrierCount,
	hasRoutingGuides,
	isGuideActive,
	showingHidden,
	onToggleGuide,
	onToggleHiddenCarriers,
}: Readonly<RoutingGuideBannerProps>) {
	return (
		<div className={styles.routingGuideBanner}>
			{isGuideActive ? (
				<span>
					{hiddenCarrierCount} Carriers are hidden due to the Applied Routing
					Guide(s).{" "}
					<button
						className={styles.viewHidden}
						disabled={!hasRoutingGuides && hiddenCarrierCount === 0}
						onClick={onToggleHiddenCarriers}
						type={"button"}
					>
						{showingHidden ? "Hide Excluded Carriers" : "View Hidden Carriers"}
						<SvgIcon icon={showingHidden ? eyeOff : eye} />
					</button>
				</span>
			) : null}
			<div className={styles.routingGuideToggle}>
				<Label>Routing Guide: {isGuideActive ? "On" : "Off"}</Label>
				<Switch
					checked={isGuideActive}
					disabled={!hasRoutingGuides && hiddenCarrierCount === 0}
					onChange={onToggleGuide}
				/>
			</div>
		</div>
	);
}
